import { fbDB } from "../config/firebase";
import { USERS_WATCH_ON, USER_CLASSCODE_UPDATE } from "./types";

export const usersWatchOn = () => async dispatch => {
  fbDB.ref(`/users`).on("value", snapshot => {
    // console.log(snapshot.val());
    return dispatch({
      type: USERS_WATCH_ON,
      payload: snapshot.val()
    });
  });
};

export const usersWatchOff = () => async dispatch => {
  fbDB.ref(`/users`).off();
};

export const userClassCodeUpdate = (
  uid,
  oldName,
  newName
) => async dispatch => {
  const classCodeRef = fbDB.ref(`/users/${uid}/classCode`);
  classCodeRef
    .child(oldName)
    .once("value")
    .then(snapshot => {
      const data = snapshot.val();
      const update = {};
      update[`/${uid}/classCode/${oldName}`] = null;
      update[`/${uid}/classCode/${newName}`] = data;
      update[`/${uid}/currentClass`] = newName;

      fbDB
        .ref("/users")
        .update(update)
        .then(() => {
          console.log("change className success");
        })
        .catch(err => {
          console.log(err);
        });
    });
};
